import React from 'react';
import { Box } from '@mui/material';
import CamerasBoxTable from './CamerasBoxTable';
import { useLazyGetListCameraQuery } from '../../services/cameras.service';
import { useAuth } from '../../hooks/useAuth';
import { CursorType } from '../../configs/constant';
import { useSelector } from 'react-redux';
import { selectCameraState, setLimit, setCursor } from '../../state/modules/camera/cameraReducer';
import Pagination from '../../common/pagination/Pagination';
import { useAppDispatch } from '../../state/store';
import { StringParam, useQueryParams } from 'use-query-params';

export const CamerasScreen = () => {
  const [getCameras] = useLazyGetListCameraQuery();
  const [paginate, setPaginate] = React.useState<CursorType>({});
  const { cursor, limit, total } = useSelector(selectCameraState);
  const dispatch = useAppDispatch();
  const [query] = useQueryParams({
    serial: StringParam,
    state: StringParam,
  });

  const {
    auth: { currentUser },
  } = useAuth();

  React.useEffect(() => {
    setPaginate({});
    dispatch(setCursor({ after: null, before: null }));
  }, [query]);

  React.useEffect(() => {
    if (currentUser) {
      getCameras({
        agencyId: currentUser?.sub_id,
        params: {
          limit,
          ...paginate,
          serial: query.serial ? query.serial : undefined,
          state: query.state && query.state !== 'all' ? query.state : undefined,
        },
      });
    }
  }, [getCameras, paginate, currentUser, limit, query]);

  const refetch = () => {
    if (currentUser) {
      getCameras({
        agencyId: currentUser?.sub_id,
        params: {
          limit,
          ...paginate,
          serial: query.serial ? query.serial : undefined,
          state: query.state && query.state !== 'all' ? query.state : undefined,
        },
      });
    }
  };

  const handleSetLimit = (limit: number) => {
    dispatch(setLimit({ limit }));
  };
  return (
    <Box mt={2} ml={2} mr={'12px'}>
      <CamerasBoxTable setPaginate={setPaginate} refetch={refetch}/>
      <Pagination paginate={cursor} total={total} setPaginate={setPaginate} limit={limit} setLimit={handleSetLimit} />
    </Box>
  );
};
